import { IdentitySessionRoot } from './_identity_session_root.component';
import { IdentitySessionWarning } from './_identity_session_warning.component';

export const IdentitySession = {
	Root: IdentitySessionRoot,
	Warning: IdentitySessionWarning,
};
